/* TRANSIT SQUARE™ — Custom JS */

// ─── OPENING: 黒幕スライドアップ (Pattern C) ───
(function() {
  // セッション内で1回だけ表示
  if (sessionStorage.getItem('ts_intro_done')) return;

  var curtain = document.createElement('div');
  curtain.id = 'ts-intro-curtain';
  curtain.innerHTML =
    '<div class="ts-intro-logo">TRANSIT SQUARE™</div>' +
    '<div class="ts-intro-sub">EST. 2013 — HIROSHIMA</div>';
  document.body.appendChild(curtain);
  // body.overflow は触らない（position:fixedなので不要、かつstickyを壊す）

  // ロゴ表示 → 黒幕スライドアップ → 除去
  setTimeout(function() {
    curtain.classList.add('ts-intro-logo-in');
  }, 100);
  setTimeout(function() {
    curtain.classList.add('ts-intro-logo-out');
  }, 1800);
  setTimeout(function() {
    curtain.classList.add('ts-intro-slide-up');
  }, 2100);
  setTimeout(function() {
    if (curtain.parentNode) curtain.remove();
    sessionStorage.setItem('ts_intro_done', '1');
  }, 3000);
})();

// ─── SNS POPUP (scroll 45% trigger, 24h cooldown) ───
(function() {
  var COOKIE_KEY = 'ts_popup_closed';
  var SCROLL_THRESHOLD = 0.45;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
  function setCookie(name, value, hours) {
    var exp = new Date(Date.now() + hours * 3600000).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + exp + '; path=/';
  }

  if (getCookie(COOKIE_KEY)) return; // 24h以内に閉じた場合はスキップ

  function createPopup() {
    var el = document.createElement('div');
    el.id = 'ts-sns-popup';
    el.innerHTML = [
      '<div class="ts-popup-inner">',
        '<button class="ts-popup-close" aria-label="Close">✕</button>',
        '<p class="ts-popup-eyebrow">STAY CONNECTED</p>',
        '<h2 class="ts-popup-title">Follow<br><em>The Square.</em></h2>',
        '<p class="ts-popup-sub">新入荷・限定情報をいち早くお届け</p>',
        '<div class="ts-popup-btns">',
          '<a href="https://instagram.com/transitsquare" target="_blank" rel="noopener" class="ts-popup-btn ts-popup-ig">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>',
            'Instagram',
          '</a>',
          '<a href="https://lin.ee/xat.0000144740.sbv" target="_blank" rel="noopener" class="ts-popup-btn ts-popup-line">',
            '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.145 2 11.243c0 4.018 2.595 7.469 6.362 9.103.278.122.657.374.754.684.087.28.057.718.028.998l-.122.726c-.037.216-.172.845.74.461 5.055-2.108 8.238-6.27 8.238-11.972C22 6.145 17.523 2 12 2z"/></svg>',
            'LINE',
          '</a>',
        '</div>',
      '</div>',
      '<div class="ts-popup-overlay"></div>'
    ].join('');
    document.body.appendChild(el);

    function closePopup() {
      el.classList.add('ts-popup-hiding');
      setTimeout(function() { if (el.parentNode) el.remove(); }, 300);
      setCookie(COOKIE_KEY, '1', 24);
    }

    el.querySelector('.ts-popup-close').addEventListener('click', closePopup);
    el.querySelector('.ts-popup-overlay').addEventListener('click', closePopup);

    requestAnimationFrame(function() { el.classList.add('ts-popup-visible'); });
  }

  var fired = false;
  function onScroll() {
    if (fired) return;
    var scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight);
    if (scrolled >= SCROLL_THRESHOLD) {
      fired = true;
      window.removeEventListener('scroll', onScroll);
      setTimeout(createPopup, 400);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// FAQ Accordion
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.ts-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.ts-faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.ts-faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });
});

// Cart count update (Shopify AJAX API)
document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var badge = document.querySelector('.ts-cart-count');
      if (badge && cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = 'flex';
      }
    }).catch(function(){});
});

// ─── MOBILE NAV ───
document.addEventListener('DOMContentLoaded', function() {
  var btn = document.querySelector('.ts-hamburger');
  var nav = document.getElementById('ts-mobile-nav');
  var overlay = document.getElementById('ts-mobile-overlay');
  if (!btn || !nav) return;

  function openNav() {
    nav.classList.add('open');
    overlay.classList.add('open');
    nav.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    // html要素でスクロールロック（bodyをいじるとstickyが壊れるため）
    document.documentElement.style.overflowY = 'hidden';
  }
  function closeNav() {
    nav.classList.remove('open');
    overlay.classList.remove('open');
    nav.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflowY = '';
  }

  btn.addEventListener('click', function() {
    nav.classList.contains('open') ? closeNav() : openNav();
  });
  overlay.addEventListener('click', closeNav);
});
